import { createContext, useContext, type ReactNode } from 'react';

import { fetchNpiSuggestionsGateway } from '../api/fetchNpiSuggestionsGateway';
import { realtimeNpiRunChannel } from '../api/realtimeNpiRunChannel';
import type { NpiRunChannel } from '../ports/npiRunChannel';
import type { NpiSuggestionsGateway } from '../ports/npiSuggestionsGateway';

type NpiSuggestionsBackend = { gateway: NpiSuggestionsGateway; channel: NpiRunChannel };

/**
 * Which backend the suggestion hooks talk to: the API for runs, the realtime
 * Event API for their hints. It defaults to the real ones, so the app mounts
 * no provider; a test or story mounts one holding in-memory ones.
 */
const NpiSuggestionsBackendContext = createContext<NpiSuggestionsBackend>({
  gateway: fetchNpiSuggestionsGateway,
  channel: realtimeNpiRunChannel,
});

export function NpiSuggestionsGatewayProvider({
  gateway,
  channel = realtimeNpiRunChannel,
  children,
}: {
  gateway: NpiSuggestionsGateway;
  channel?: NpiRunChannel;
  children: ReactNode;
}) {
  return (
    <NpiSuggestionsBackendContext.Provider value={{ gateway, channel }}>
      {children}
    </NpiSuggestionsBackendContext.Provider>
  );
}

export function useNpiSuggestionsBackend() {
  return useContext(NpiSuggestionsBackendContext);
}
